import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import {
  AUDIT_LOG_ITEMS_LIST_SEPARATOR,
  getAuditLogMovedItems,
  IEntityPropertyItemsChange,
} from "@ryde/shared";

import { EntityPropertyOrder } from "./entity-property-order";
import { SearchHighlight } from "./search-highlight";

interface IEntityPropertyItemsChangeProps {
  items: IEntityPropertyItemsChange;
}

/** What came into and went out of a collection, and for stations the order before and after. */
export const EntityPropertyItemsChange = ({
  items,
}: IEntityPropertyItemsChangeProps): ReactElement => {
  const { t } = useTranslation();
  const { added, removed, orderBefore, orderAfter } = items;
  const moved =
    orderBefore && orderAfter
      ? getAuditLogMovedItems({ before: orderBefore, after: orderAfter })
      : new Set<string>();

  return (
    <div className="entityProperty__items">
      {!!added.length && (
        <div className="entityProperty__items-row">
          <span className="entityProperty__items-label">
            {t("auditLog.changes.added")}:
          </span>
          <SearchHighlight
            className="entityProperty__new-value"
            text={added.join(AUDIT_LOG_ITEMS_LIST_SEPARATOR)}
          />
        </div>
      )}
      {!!removed.length && (
        <div className="entityProperty__items-row">
          <span className="entityProperty__items-label">
            {t("auditLog.changes.removed")}:
          </span>
          <SearchHighlight
            className="entityProperty__removed-value"
            text={removed.join(AUDIT_LOG_ITEMS_LIST_SEPARATOR)}
          />
        </div>
      )}
      {orderBefore && orderAfter && (
        <div className="entityProperty__items-row">
          <span className="entityProperty__items-label">
            {t("auditLog.changes.orderChanged")}:
          </span>
          <div className="entityProperty__items-order">
            <EntityPropertyOrder
              order={orderBefore}
              side="before"
              moved={moved}
              otherSide={new Set(orderAfter)}
            />
            <EntityPropertyOrder
              order={orderAfter}
              side="after"
              moved={moved}
              otherSide={new Set(orderBefore)}
            />
          </div>
        </div>
      )}
    </div>
  );
};
